module.exports = __webpack_public_path__ + "static/media/maciej-polak.256b4be0.jpg";